// import { is } from "date-fns/locale";
import { saveOfflineRequest } from '../utils/indexedDB';

const BASE_API = 'https://myinventory.myatos.net/api/';
//const BASE_API = 'http://localhost:8000/api/';

const genericImg = 'data:image/jpeg;base64,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'

export async function signIn(email, password) {
    const req = await fetch(`${BASE_API}login/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ username: email, password })
    });

    if (!req.ok) {
        const error = await req.json();
        throw new Error(error.detail || "Erro no login");
    }

    const json = await req.json();

    
    localStorage.setItem('token', json.access);
    localStorage.setItem('refresh', json.refresh);

    return json; 
}


export async function getUser(email) {
    const req = await fetch(`${BASE_API}get_user/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({email})
    });
    const json = await req.json();
    return json;
}

export async function createUser(status, sobrenome, nome, dasId, email) {
    const req = await fetch(`${BASE_API}create_user/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ dasId, status, sobrenome, nome, email })
    });
    const json = await req.json();
    return json;
}

export async function driveitcreate(user, update) {
  const payload = { user, update };

  try {
    const req = await fetch(`${BASE_API}driveitcreate/`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    if (!req.ok) {
            throw new Error(`HTTP error! status: ${req.status}`);
    }
    const json = await req.json();
    return json;

  } catch (err) {      
    await saveOfflineRequest({ type: 'create', payload });    
    return { offline: true };
  }
}


export async function driveitarchive() {   

    try {
        const req = await fetch(`${BASE_API}driveitarchive/`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            }            
        });

        const json = await req.json();
        return json;
    } catch (err) {
        
    }
}

export async function driveitarchiveid(id) {   

    try {
        const req = await fetch(`${BASE_API}driveitarchive/`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ id: id })
        });

        const json = await req.json();
        return json;
    } catch (err) {
        
    }
}

export async function driveitupdate(user, index, update) {
    const payload = { user, index, update };

    try {
        const req = await fetch(`${BASE_API}driveitupdate/`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });

        const json = await req.json();
        return json;
    } catch (err) {        
        await saveOfflineRequest({ type: 'update', payload });
        return { offline: true };
    }
}

export async function reflexcreate(user, update) {
    const req = await fetch(`${BASE_API}reflexcreate/`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({user, update })
    });
    const json = await req.json();

    return json;
}

export async function reflextupdate(user, index, update) {
    const req = await fetch(`${BASE_API}reflexupdate/`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ user, index, update })
    });
    const json = await req.json();

    return json;
}


export async function getDriveit() {
    await refreshToken();
    if (!navigator.onLine) {        
        return { offline: true };
    }

    const token = localStorage.getItem('token');
    if (!token) {
        throw new Error('Usuário não autenticado');
    }

    const req = await fetch(`${BASE_API}driveit/`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            'Authorization': `Bearer ${token}`
        }        
    });

    if (!req.ok) {
        const error = await req.json();
        throw new Error(error.detail || 'Erro ao buscar equipamentos');
    }

    const json = await req.json();
    return json;
}


export async function getReflex() {
    const req = await fetch(`${BASE_API}reflex/`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }        
    });
    const json = await req.json();
    return json;
}

export async function getimagesDriveIT(index) {
    try {
        const req = await fetch(`${BASE_API}driveitgetimage/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ index })
        });

        if (!req.ok) throw new Error('Erro na resposta');

        const json = await req.json();
        return json;

    } catch (error) {        
        return [
            {
                filename: "generic.jpg",
                image: genericImg,
                slot: 1
            },
            {
                filename: "generic.jpg",
                image: genericImg,
                slot: 2
            },
            {
                filename: "generic.jpg",
                image: genericImg,
                slot: 3
            }
        ];
    }
}

export async function uploadimagesDriveIT(index, image, slot, filename) {
    const payload = { index, image, slot, filename };

    try {
        const req = await fetch(`${BASE_API}driveitimage/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });

        const json = await req.json();
        return json;
    } catch (err) {
        // Salva para envio posterior
        await saveOfflineRequest({ type: 'upload', payload });
        return { offline: true };
    }
}

export async function getimagesReflex(index) {
    const req = await fetch(`${BASE_API}reflexgetimage/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({index})        
    });
    const json = await req.json();
    return json;
}

export async function uploadimagesReflex(index,image,slot,filename) {
    
    const req = await fetch(`${BASE_API}refleximage/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({index, image, slot, filename})        
    });
    const json = await req.json();
    return json;
}

async function refreshToken() {
  const refresh = localStorage.getItem('refresh');
  if (!refresh) return null;

  const response = await fetch('https://myinventory.myatos.net/api/refresh/', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ refresh })
  });

  if (!response.ok) return null;

  const data = await response.json();
  localStorage.setItem('token', data.access);
  return data.access;
}